<template>
<div class="mr-2 mt-1">
  <div class="row">
    <div class="col-md-12 col-12">
      <div  class=" d-flex flex-row-reverse">
        <p class="text-primary"><strong>Total Records : </strong><span class="text-success">{{totalNumberOfRecords}}</span></p>
      </div>
    </div>
    <div class="col-md-12 col-12">
      <div v-if="typeof (hidePerPage) == 'undefined'" class=" d-flex flex-row-reverse">
        <div class="form-group">
          <label class="form-label" for="user-role">Per Page</label>
          <select id="user-role" v-model="perPage" class="form-control">
            <option value="10" selected>10</option>
            <option v-show="parseInt(totalNumberOfRecords) > 10" value="20">20</option>
            <option v-show="parseInt(totalNumberOfRecords) > 20" value="30">30</option>
            <option v-show="parseInt(totalNumberOfRecords) > 30" value="50">50</option>
            <option v-show="parseInt(totalNumberOfRecords) > 50" value="100">100</option>
            <option v-show="parseInt(totalNumberOfRecords) > 100" value="200">200</option>
            <option v-show="parseInt(totalNumberOfRecords) > 200" value="300">300</option>
            <option v-show="parseInt(totalNumberOfRecords) > 300" value="400">400</option>
            <option v-show="parseInt(totalNumberOfRecords) > 400" value="500">500</option>
          </select>
        </div>
      </div>
    </div>
  </div>
  <div class=" mt-1" v-if="typeof(exportData) != 'undefined'">
    <div class="row">
      <div class="col-md-12 col-12">
        <div  class=" d-flex flex-row-reverse">
          <div class="mb-1">
            <button  type="button" class="btn-sm btn btn-gradient-success" @click="exportData.cta('excel')">
<!--              <div v-show="excelLoader"  class="spinner-border text-white spinner-border-sm mr-1"></div>-->
              <BIconFileEarmarkExcelFill width="15" height="15"/>
              Export Excel
            </button>
            <button v-if="typeof(hidePdfExportButton) == 'undefined'"  type="button" class="btn-sm btn btn-gradient-danger ml-1" @click="exportData.cta('pdf')">
<!--              <div v-show="pdfLoader" class="spinner-border text-white spinner-border-sm mr-1"></div>-->
              <BIconCloudDownloadFill width="15" height="15"/>
              Export PDf
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
  <SkeletonLoader
      v-if="loading"
      :loading="loading"
      :headerLength="tableHeaderValues"
  ></SkeletonLoader>
  <div class="card-datatable table-responsive pt-0 " v-show="!loading">
    <table class="user-list-table table  table-hover   " :class="customClass">
      <thead>
      <tr>
        <th v-if="typeof(tableAccordian) != 'undefined'"></th>
        <!--      <th class="table-head">S.No</th>-->
        <th v-if="typeof(loadMore) == 'undefined' && typeof(useCustomRows) == 'undefined'">S.No</th>
        <th class="table-head" v-for="(header, headerKey) in tableHeaderValues" :key="headerKey">
          {{ header.title }}
          <span
              v-if="typeof header.titleHtml != 'undefined'"
              v-html="header.titleHtml"
          >

            </span>
        </th>
        <th class="table-head" v-if="typeof(forceShowActionHeader) != 'undefined' || typeof(actions) != 'undefined' && actions.length">Actions</th>
      </tr>
      </thead>
      <tbody>
      <tr v-if="!list.length && !loading">
        <td :colspan="actions.length || typeof(forceShowActionHeader) != 'undefined'? tableHeaderValues.length +1 : tableHeaderValues.length"
            class="font-weight-bolder font-medium-2" style="text-align: center">No data avaliable
        </td>
      </tr>
      <template v-if="useCustomRows">
        <slot name="row" v-for="(row, index) in list" :row="row" :index="index" :count="count"></slot>
      </template>
      <template v-else>
        <template :key="index" v-for="(row, index) in list">
        <tr>
          <!--      <td v-if="typeof(loadMore) == 'undefined'" >{{ count + (index + 1) }}</td>-->
          <!--      <td v-if="typeof(loadMore) != 'undefined'" >{{ index + 1}}</td>-->
          <td v-if="typeof(tableAccordian) != 'undefined'">
            <button type="button" v-if="resolveAccordianConditionalRendering(row)" class="btn btn-sm btn-icon font-weight-bolder font-medium-1 rounded-circle btn-warning waves-effect waves-float waves-light" data-toggle="collapse"  :data-target="'#demo'+index" @click="accordionToShow  = index">
              +
            </button>
          </td>
          <td v-if="typeof(loadMore) == 'undefined'">{{ count + (index + 1) }}</td>
          <td v-for="(value, valueKey) in tableHeaderValues" :key="valueKey">
            <span :class="typeof(value.customClass) == 'undefined'? 'd-flex' : value.customClass "
                  v-if="typeof(value.html) != 'undefined'"
                  @click="typeof(value.cta) != 'undefined'? value.cta(row, index) : null"
                  v-html="resolve(value, row)"></span>
            <span v-else>{{ resolve(value, row) }}</span>
          </td>
          <td v-if="typeof(actionDropdown) != 'undefined' || typeof(showOnlyAccordian) != 'undefined'" class="d-flex">
            <div class="dropdown" v-if="typeof(showOnlyAccordian) == 'undefined'">
              <button type="button" class="btn btn-sm dropdown-toggle hide-arrow" data-toggle="dropdown">
                <BIconThreeDotsVertical/>
              </button>
              <div class="dropdown-menu" v-if="tableButtons.length">
                <a class="dropdown-item" v-for="(btn, btnKey) in tableButtons[index]" :key="btnKey"
                   @click="btn.cta(row, index, btnKey)" href="javascript:void(0);">
                <span>{{
                    typeof (btn.conditionalRendering) == 'undefined' ? btn.title : btn.condition(row, index, btnKey)
                  }}</span>
                </a>
              </div>
            </div>
<!--            <button type="button" v-if="resolveAccordianConditionalRendering(row)" class="btn btn-sm btn-icon font-weight-bolder font-medium-1 rounded-circle btn-warning waves-effect waves-float waves-light" data-toggle="collapse"  :data-target="'#demo'+index" @click="accordionToShow  = index">-->
<!--              +-->
<!--            </button>-->
          </td>
          <td v-if="tableButtons.length && typeof(actionDropdown) == 'undefined'" class="d-flex">
            <template v-for="(btn, btnKey) in tableButtons[index]" :key="btnKey">
              <template v-if="typeof (btn.toggleSwitch) != 'undefined'">
                <div class="custom-control custom-switch" :class="typeof(btn.class) != 'undefined'? btn.class : '' "
                     v-if="typeof (btn.conditionalRendering) == 'undefined' ? true : btn.condition(row, index, btnKey)">
                  <input type="checkbox" class="custom-control-input"
                         :checked="btn.toggleSwitchCondition(row, index, btnKey)" :id="index+'_'+btnKey"
                         @change="btn.cta(row, index, btnKey)"/>
                  <label class="custom-control-label" :for="index+'_'+btnKey">
                  </label>
                </div>
              </template>
              <template v-else>
                <Button
                    v-if="typeof (btn.conditionalRendering) == 'undefined' ? true : btn.condition(row, index, btnKey)"
                    :class="typeof(btn.class) != 'undefined'? btn.class : 'btn-primary' "
                    @click="btn.cta(row, index, btnKey)" class="btn btn-sm" :loading="btn.loading">
                  {{ btn.title }}
                </Button>
              </template>

            </template>
          </td>
        </tr>
        <tr v-if="typeof(tableAccordian) != 'undefined'">
          <td :colspan="resolveAccordianCollspanLength(actions,tableHeaderValues)" class="hiddenRow ">
            <div class="collapse" :id="'demo'+index">
              <div class="card-body">
                <div class="card">
                  <template v-for="(accrodionArrayItem,accrodionArrayIndex) in tableAccordian" :key="accrodionArrayIndex">
                    <div class="row pl-5 font-weight-bolder font-medium-2" v-if="!accrodionArrayItem.body.getData(row, index).length && accrodionArrayIndex <= 0">
                      No Data Avaliable
                    </div>
                    <template v-if="accrodionArrayItem.body.getData(row, index).length">
                      <h4 class="ml-2 mt-4" v-if="typeof(accrodionArrayItem.heading) != 'undefined'">{{accrodionArrayItem.heading}}</h4>

                      <table class="table border-dark  badge-glow mt-2">
                        <thead>
                        <tr>
                          <th v-for="(accordianHead,headIndex) in accrodionArrayItem.header" :key="headIndex">{{accordianHead.title}}</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(accordianBodyItem,accordianBodyIndex) in accrodionArrayItem.body.getData(row, index)" :key="accordianBodyIndex">
                          <td v-html="subBodyItem" v-for="subBodyItem in accordianBodyItem" ></td>
                        </tr>
                        </tbody>
                      </table>
                    </template>

                  </template>
                </div>
              </div>

            </div>
          </td>
        </tr>
      </template>
      </template>
      </tbody>
    </table>
<!--    <CommonPaginator :url="requestUrl" :bodyData="bodyData" @getRecords="getRecords" :force="force"-->
<!--                     :loadMore="loadMore" :defaultLimit="perPage"/>-->
    <CommonPaginator
        :url="requestUrl"
        :bodyData="bodyData"
        @getRecords="getRecords"
        :force="force"
        :loadMore="loadMore"
        :defaultLimit="perPage"
        @loading="getLoadingState"
        @skeletonLoading="skeletonLoading"
        :headerLength="tableHeaderValues"
        :responseDataKey="responseDataKey"
    />
  </div>
</template>

<script>

import Button from "@/components/common/Button";
import { mapState } from 'vuex'
export default {
  components: {Button},
  props: ['url', 'tableHeaderValues', 'actions', 'mutedData', 'filteredData', 'customClass', 'actionDropdown', 'loadMore', 'hidePerPage','tableAccordian','forceShowActionHeader','showOnlyAccordian','accordianCondition','exportData','hidePdfExportButton','useCustomRows','responseDataKey'],
  data() {
    return {
      loading: true,
      list: [],
      force: false,
      count: 0,
      tableButtons: [],
      perPage: 10,
      accordionToShow: -1,
      totalNumberOfRecords:0
    }
  },
  mounted() {
  },
  methods: {
    resolveAccordianConditionalRendering(row){
      let result = false
      if(typeof(this.tableAccordian) != 'undefined'){
        result = true
      }
      if(typeof(this.accordianCondition) != 'undefined'){
        result = this.accordianCondition.condition(row)
      }
      return result
    },
    resolveAccordianCollspanLength(actions,tableHeaderValues){
      if(actions.length){
        return tableHeaderValues.length +1
      }else{
        return tableHeaderValues.length
      }
    },
    skeletonLoading(val) {
      if(typeof(this.loadMore) != 'undefined'){
        this.loading = false
      }else{
        this.loading = val;
      }
    },
    getLoadingState(loading) {
      if(typeof(this.loadMore) != 'undefined'){
        this.loading = false
      }
      else{
        this.loading = loading;
      }

    },
    getRecords(response) {
      /*close accordian*/
      var elems = document.querySelectorAll(".collapse");

      [].forEach.call(elems, function(el) {
        el.classList.remove("show");
      });

      if (typeof (this.loadMore) != 'undefined') {
        for (let i = 0; i < response.data.length; i++) {
          this.list.push(response.data[i])
        }
      } else {
        this.list = response.data
      }
      this.totalNumberOfRecords = response?.pagination?.total ?? 0
      let currentPage = response.pagination.currentPage
      this.$store.commit('setChosenPage', currentPage);
      this.$emit('pageChange', currentPage);
      this.count = response.pagination.perPage * (currentPage - 1)
      this.$store.commit('setChosenPerPage', response.pagination.perPage);

      this.tableButtons = this.getCloneActions(this.list)
    },
    resolve(data, obj) {
      var value = data.valueKey.split('.').reduce(function (prev, curr) {
        return prev ? prev[curr] : null
      }, obj || self)
      if (typeof (data.alter) != "undefined") {
        return data.alter(value, obj)
      } else {
        return typeof (value) != "undefined" ? value : '-'
      }
    },
    getCloneActions(list) {
      var actions = []
      if (this.actions.length > 0) {
        list.forEach(() => {
          var newActions = []
          this.actions.forEach((obj) => {
            var newObj = {}
            Object.assign(newObj, obj)
            newActions.push(newObj)
          })
          actions.push(newActions)
        })
      }
      return actions
    }
  },
  computed: {
    ...mapState(['excelLoader','pdfLoader']),
    requestUrl() {
      let url = ''
      url = this.url
      return url
    },
    bodyData() {
      if(typeof(this.loadMore) != 'undefined'){
        this.list  = []
      }
      let body = {}
      if (typeof (this.filteredData) != "undefined" && this.filteredData != null && Object.keys(this.filteredData).length > 0 && this.filteredData != "") {
        body = this.filteredData
      }
      return body
    }
  },
  watch: {
    mutedData(val) {
      for (let [key, value] of Object.entries(val)) {
        if (key == 'index') {
          var index = value
          continue
        }
        this.list[index][key] = value
      }
    },
  }
}
</script>
<style>
.hiddenRow {
  padding: 0 !important;
}
</style>

